var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[_c('v-sheet',{staticClass:"border-b"},[_c('div',{staticClass:"text-center main-breaking"},[_c('div',{ref:"newsText",staticClass:"news-text",attrs:{"data-text":_vm.dataText}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }